export const isModalBuscaCamerasOpened = (state = false, action) => {
  switch (action.type) {
    case 'ABRE_MODAL_BUSCA_CAMERAS': return true;
    case 'FECHA_MODAL_BUSCA_CAMERAS': return false;
    default: return state;
  }
};

export const buscaCamerasFiltro = (state = '', action) => {
  switch(action.type) {
    case 'FILTRO_CAMERAS_CHANGED': return action.filtro;
    default: return state;
  }
};

export const buscaCamerasIncluiCamerasPublicas = (state = false, action) => {
  switch(action.type) {
    case 'INCLUI_CAMERAS_PUBLICAS_CHANGED': return action.inclui;
    default: return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/buscaCameras.js